import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import { Layout } from "../../../components/Layout";
import { OrderDetails } from "../../../components/order";
import { useOrder } from "../../../hooks/useOrder";
import { Button, BUTTON_COLORS, BUTTON_TYPE } from "../../../components/Button";
import { USER_AUTH_URL } from "../../../config";
import { useAuthTools } from "../../../providers/authProvider";
import { useCart } from "../../../providers/cart";

export default function Order({ admin = false }: { admin?: boolean }) {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuthTools();
  const { resetCart } = useCart();
  // const [order, setOrder] = useState<OrderData | null>(null);
  const [orderRequest] = useOrder({ slug: slug });

  if (orderRequest.error) {
    const renderMe = [<div>Sorry, there was an issue...</div>];

    if (typeof orderRequest.error === "string") {
      renderMe.push(<div>{orderRequest.error}</div>);
    }
    if (orderRequest.error.errorInfo?.authorizationResult) {
      renderMe.push(
        <div>
          {orderRequest.error.errorInfo.authorizationResult.reason ??
            orderRequest.error.message}
        </div>,
        <div>
          {orderRequest.error.errorInfo.authorizationResult.remedies
            ? orderRequest.error.errorInfo.authorizationResult.remedies?.map(
                (remedy: string) =>
                  remedy === "login" ? (
                    <Link
                      className={BUTTON_TYPE.small + BUTTON_COLORS.primary}
                      to={USER_AUTH_URL("login", {
                        flow: "resume",
                        to: location.pathname,
                      })}
                    >
                      Login
                    </Link>
                  ) : remedy === "logout" ? (
                    <Button
                      onClick={() => {
                        logout?.();

                        resetCart?.();
                        navigate(
                          USER_AUTH_URL("login", {
                            flow: "resume",
                            to: location.pathname,
                          }),
                        );
                      }}
                      btnType={"small"}
                      btnColor={"primary"}
                    >
                      Logout
                    </Button>
                  ) : (
                    <Button
                      onClick={() => {}}
                      btnType={"small"}
                      btnColor={"nav"}
                    >
                      {remedy} - UNTESTED
                    </Button>
                  ),
              )
            : null}
        </div>,
      );
    }
    if (renderMe.length < 2) {
      renderMe.push(
        <div>{orderRequest.error.message || orderRequest.error.error}</div>,
        <div>{JSON.stringify(orderRequest.error)}</div>,
      );
    }

    return (
      <Layout loading={orderRequest.status === "loading"} headerStyle="sm">
        <div>{renderMe}</div>
      </Layout>
    );
  }

  return (
    <Layout loading={orderRequest.status === "loading"} headerStyle="sm">
      <OrderDetails
        {...orderRequest}
        showItems
        showCreateShipmentBtn={admin}
        showShipmentItems={admin}
        showViewShipmentBtn={admin}
        showOriginalItems={admin}
        admin={admin}
      />
    </Layout>
  );
}
